import { Subject, Observable } from 'rxjs';
import { Inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class BaseEventsService {
  private subject = new Subject<EventsServiceData>();
  private filterConditionsSubject = new Subject<SearchItemModel[]>();
  private dataSubject = new Subject<any[]>();
  private filterCriterions!: Criterion[];
  public resetSelections$ = new Subject<boolean>();
  public selectAll$ = new Subject<boolean>();
  public dataWasLoaded!: boolean;

  private filters!: SearchItemModel[];
  private order!: Order[];
  private pagination!: Pagination;
  private data!: any[];
  public eventServiceName: string;

  constructor(@Inject(String) eventServiceName: string) {
    this.eventServiceName = eventServiceName;
  }

  public getSubject(): Observable<EventsServiceData> {
    return this.subject.asObservable();
  }

  public getDataSubject(): Observable<any[]> {
    return this.dataSubject.asObservable();
  }

  public onSelected(id: string[]): void {
    this.subject.next({ id, action: EventsServiceAction.Select });
  }

  public onReviewLink(payload: any): void {
    this.subject.next({ id: payload, action: EventsServiceAction.ReviewLink });
  }

  public onReviewDocument(payload: any): void {
    this.subject.next({ id: payload, action: EventsServiceAction.ReviewDocument });
  }

  public onQueryLink(payload: any): void {
    this.subject.next({ id: payload, action: EventsServiceAction.QueryLink });
  }

  public onAddClausesLink(payload: any): void {
    this.subject.next({ id: payload, action: EventsServiceAction.AddClausesLink });
  }

  public onEditProperties(payload: any): void {
    this.subject.next({ id: payload, action: EventsServiceAction.EditProperties });
  }

  public onUnlink(payload: any): void {
    this.subject.next({ id: payload, action: EventsServiceAction.Unlink });
  }

  public onView(payload: any): void {
    this.subject.next({ id: payload, action: EventsServiceAction.View });
  }

  public onEdit(payload: any): void {
    this.subject.next({ id: payload, action: EventsServiceAction.Edit });
  }

  public onSendReport(payload: any): void {
    this.subject.next({ id: payload, action: EventsServiceAction.SendReport });
  }

  public onRequestSignatures(payload: any): void {
    this.subject.next({ id: payload, action: EventsServiceAction.RequestSignatures });
  }

  public onEditInDesktop(payload: any): void {
    this.subject.next({ id: payload, action: EventsServiceAction.EditInDesktop });
  }

  public onRelaunchReview(payload: any): void {
    this.subject.next({ id: payload, action: EventsServiceAction.RelaunchReview });
  }

  public onDelete(payload: any): void {
    this.subject.next({ id: payload, action: EventsServiceAction.Delete });
  }

  public onDeactivate(payload: any): void {
    this.subject.next({ id: payload, action: EventsServiceAction.Deactivate });
  }

  public onSearch(payload: any): void {
    this.subject.next({ id: payload, action: EventsServiceAction.Search });
  }

  public onCancel(payload: any): void {
    this.subject.next({ id: payload, action: EventsServiceAction.Cancel });
  }

  public onApply(payload: any): void {
    this.subject.next({ id: payload, action: EventsServiceAction.Apply });
  }

  public onCase(payload: any): void {
    this.subject.next({ id: payload, action: EventsServiceAction.Case });
  }

  public onDetails(payload: any): void {
    this.subject.next({ id: payload, action: EventsServiceAction.Details });
  }

  public onDownload(payload: any): void {
    this.subject.next({ id: payload, action: EventsServiceAction.Download });
  }

  public onPreview(payload: any): void {
    this.subject.next({ id: payload, action: EventsServiceAction.Previw });
  }

  public onNameClick(payload: any): void {
    this.subject.next({ id: payload, action: EventsServiceAction.NameClick });
  }

  public getFilterConditionsSubject(): Observable<SearchItemModel[]> {
    return this.filterConditionsSubject.asObservable();
  }

  public saveFilters(filters: SearchItemModel[]): void {
    // localStorage.setItem(this.filterStorageName, JSON.stringify(filters));
    this.filters = filters;
  }

  public getFilters(): SearchItemModel[] {
    // if (!this.filters) {
    //   const filtersData = localStorage.getItem(this.filterStorageName);

    //   if (filtersData) {
    //     this.filters = JSON.parse(filtersData);
    //   }
    // }

    return this.filters;
  }

  public onFilter(filters: SearchItemModel[]): void {
    this.saveFilters(filters);

    //this.waitFor(this.dataWasLoaded, () => {
    this.filterConditionsSubject.next(filters);
    //});
  }

  public waitFor(condition: boolean, callback: any): any {
    if (!condition) {
      // send that
      window.setTimeout(this.waitFor.bind(null, condition, callback), 50);
    } else {
      callback();
    }
  }

  public setFilterCriterions(criterions: Criterion[]): void {
    // localStorage.setItem(this.filterCriterionsStorageName, JSON.stringify(criterions));
    this.filterCriterions = criterions;
  }

  public getFilterCriterions(): Criterion[] {
    // if (!this.filterCriterions) {
    //   this.filterCriterions = JSON.parse(
    //     localStorage.getItem(this.filterCriterionsStorageName) || '',
    //   );
    // }

    return this.filterCriterions;
  }

  public saveOrder(order: Order[]): void {
    this.order = order;
  }

  public getOrder(): Order[] {
    return this.order;
  }

  public savePagination(pagination: Pagination): void {
    this.pagination = pagination;
  }

  public getPagination(): Pagination {
    return this.pagination;
  }

  public setData(data: any[]): void {
    this.data = data;
    this.dataSubject.next(data);
  }

  public getData(): any[] {
    return this.data;
  }

  public resetPagination(): void {
    this.pagination = {
      start: 0,
      length: this.pagination?.length ? this.pagination.length : 10,
    } as Pagination;
  }

  get filterStorageName(): string {
    return this.eventServiceName + '_filters';
  }

  get filterCriterionsStorageName(): string {
    return this.eventServiceName + '_filterCriterions';
  }
}

export class EventsServiceData {
  id: any;
  action!: EventsServiceAction;
}

export class Pagination {
  start!: number;
  length!: number;
}

export enum EventsServiceAction {
  View = 1,
  Edit = 2,
  Delete = 3,
  Search = 4,
  Cancel = 5,
  Apply = 6,
  Case = 7,
  Details = 8,
  Download = 9,
  Previw = 12,
  Select = 13,
  ReviewLink = 14,
  QueryLink = 15,
  AddClausesLink = 16,
  EditProperties = 17,
  EditInDesktop = 18,
  SendReport = 19,
  NameClick = 20,
  Unlink = 21,
  RelaunchReview = 22,
  ReviewDocument = 23,
  RequestSignatures = 24,
  Deactivate = 25,
}

export class SearchItemModel {
  criterion!: number; // Criterion id
  operator!: number; // SearchOperator id
  searchValue!: string; // value to be searched
  type!: number; // SearchCriterionsDataType
  controlName!: string;
  // entity!: string;
}

export class Criterion {
  id?: number;
  title?: string;
  data?: string[];
  type?: number; // SearchCriterionsDataType
  // entity?: string;
}

export class Order {
  column?: number;
  dir?: PaginationOrder;
}

export enum PaginationOrder {
  Asc = 'Asc',
  Desc = 'Desc',
}
